module.exports = __webpack_public_path__ + "static/img/Lutepure-01.199124e5.jpg";